import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../Reducers/rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Large seed / market / trades payloads make these checks slow in development.
      // They are already disabled in production builds.
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "managers/setManagers",
          "marketData/setMarkets",
          "marketData/setMarketData",
          "trades/setTrades",
          "funds/setFunds",
          "lots/setLots",
          "tickers/setTickers",
          "accounting/setAccountingData",
        ],
        ignoredPaths: [
          "_persist",
          "managers",
          "marketData",
          "trades",
          "funds",
          "lots",
          "tickers",
          "accounting",
        ],
        warnAfter: 128,
      },
      immutableCheck: {
        ignoredPaths: [
          "marketData.RawMarketData",
          "marketData",
          "trades.trades",
          "managers",
          "funds",
          "lots",
        ],
        warnAfter: 128,
      },
    }),
  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== "production",
});
